import { ActionType } from './action';

const threadVotesReducer = (threadVotes = [], action = {}) => {
  switch (action.type) {
    case ActionType.UP_VOTE_THREAD:
      return [action.payload.vote, ...threadVotes];
    case ActionType.DOWN_VOTE_THREAD:
      return [action.payload.vote, ...threadVotes];
    case ActionType.NEUTRALIZE_VOTE_THREAD:
      return [action.payload.vote, ...threadVotes];
    default:
      return threadVotes;
  }
};

export default threadVotesReducer;
